<div class="sections">
  <div class="card header-card">
    <div class="card-header display-flex billing-header">
      <div class="flex-start gap-3">
        <button class="btn btn-light" (click)="goBack()">
          <i class="fa fa-angle-left"></i>
          Back
        </button>
        <h5 class="mb-0">Monthly Bill - {{ resourceGroup }}</h5>
      </div>
      <div class="flex-gap billing-actions">
        <label class="font-bold" for="azureServicesMonth">Month</label>
        <input
          id="azureServicesMonth"
          autocomplete="off"
          class="datetimepicker-services form-control month-input"
          type="text"
        />
        <button class="btn btn-primary-soft" (click)="load()" [disabled]="loading">
          Refresh
        </button>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header display-flex">
      <div></div>
      <div></div>
      <div class="flex-start">
        <span class="mr-10"> Total: <span class="bold_text">${{ getTotalCost() }}</span> </span>
        <div>
          <button class="btn btn-success-soft" id="dropdownMenuLinkID">
            Download
            <i class="fa fa-caret-down" aria-hidden="true"></i>
            <div class="dropdownMenuLink">
              <div class="dropdown-item" (click)="exportPDFTrigger($event)">PDF</div>
              <div class="dropdown-item" (click)="loadEC2Ddata($event)">CSV</div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body flow-auto">
      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Service Name</th>
            <th>Cost</th>
          </tr>
        </thead>
        <tbody *ngIf="rows.length > 0">
          <tr *ngFor="let row of rows; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span class="nav-link p-0" (click)="openServiceBreakdown(row)">
                {{ row.service_name }}
              </span>
            </td>
            <td>${{ (+row.cost || 0).toFixed(2) }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading && rows.length === 0">
          <tr>
            <td colspan="3" class="center">No data found</td>
          </tr>
        </tbody>
        <tbody *ngIf="loading">
          <tr>
            <td colspan="3" class="center">
              <img src="../assets/img/loading_2.svg" alt="loading" class="width-18" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
